<template>
    <div id="log">
        <div id="agreement"
             v-if="IsArge">
            <div class="body-a">
                <div class="a-title"
                     @click="closeArgee">
                    关闭
                </div>
                <div style="overflow-y: scroll;height: 500px;padding: 0 30px">
                    本文由组团推市场规则团队撰写，囊括了组团推旗下的美逛的推广规则。全文从概要、准入、行业推广、信息规则、处罚规则五大部分，进行了权威、细致的解读。贯穿用户准入、推广、退出各环节的规则要点，帮助用户了解哪些推广行为可为，哪些推广行为不可为。
                    欢迎已经加入组团推，以及还未加入组团推的您打开本宝典。希望您能通过本宝典熟悉了解组团推的营销推广规范，解决在推广过程中遇到的困惑，并找到应对方案。 <br>
                    <h3 style="text-align: center;margin: 20px 0">组团推推广者规范</h3>
                    <h5>第一章    概述</h5>
                    第一条     为保障组团推推广者（以下简称为“推广者”）的合法权益，维护组团推正常运营秩序，根据《组团推服务协议》、《淘宝客推广软件产品使用许可协议》等规定，特制定本规范。 <br>
                    第二条     组团推随时可能根据业务的发展等变更本规范并在组团推网站（www.zutuan.cn，下同）上予以公告或以其他形式通知推广者，推广者应及时查看。如推广者不同意相关变更，应立即停止使用相应服务；如推广者继续使用相应服
                    务的，视为同意变更后的规范。 <br>
                     
                    <h5>第二章    定义</h5>
                    第三条     推广客户：使用组团推和（或）其关联公司提供的推广软件或广告服务等，以推广商品（含服务，下同）、店铺、网站等的单位或个人。 <br>
                    第四条     推广者：使用组团推平台里的服务，为推广客户提供推广、购物省钱和赚钱等服务的单位或个人；及以其他方式认可并承诺遵守本规范的其他单位或个人。<br>
                    第五条     组团推品牌：组团推及其关联公司的域名、商标、公司名称、产品、服务名称等的中文、英文、拼音、图形等的全部或者其核心部分。<br>
                     
                    <h5>第三章    通用规范</h5>
                    本章节规定了各类型推广者推广时应遵守的通用规范。<br>
                    第六条     推广资源备案管理：<br>
                    （一）    推广者应按要求及时、详尽、准确的提交推广资源备案。<br>
                    （二）    推广者提交推广资源备案后，组团推可能进行审查，该审查仅为表面查看，不表示组团推有能力或有义务对推广者提交信息的真实性、准确性、合法性等进行确认。<br>
                    第七条    推广渠道不得出现流量异常现象。流量异常包括如下三种情形：<br>
                    （一）    通过程序、脚本模拟或其他形式进行或产生非正常的浏览、点击、交易行为等。<br>
                    （二）    流量劫持。<br>
                    （三） 内部互挖，恶意竞争获取的流量。<br>
                    1、第一次发现，禁用创建代理功能一个月；<br>
                    2、第二次发现，直接停用发展代理功能（包括手动创建代理、自动裂变等功能）！<br>

                    （四） 通过获取刷单、店淘、店群、淘系评价等包括但不仅限于淘宝禁止的方式获取的流量。<br>
                    （五） 其他组团推有合理理由证明的流量分布异常（如流量来源、分布等）情况。<br>

                    第八条 尊重组团推及其相关业务与组团推品牌，需遵循以下规范：
                    （一） 禁止在淘宝所有相关的渠道进行推广组团和美逛，不得通过某些工具把发展组团合伙人和美逛代理的推广链接、淘口令、文字、图片、页面等包括但不限这些形式在淘系渠道进行推广，如：美逛xx淘宝店铺、美
                    逛激活码的淘宝单品，淘口令跳转、淘宝论坛、联盟论坛、含有与淘宝+组团+美逛的短信群发等等（正常在社群中推广美逛上的商品给用户是不影响的，用淘口令是可以的）<br>
                    （二）不得在百度、百度知道、贴吧推广组团相关页面。包含自己制作的推广页面。<br>
                    （三）组团推推广者有义务通知并约束自己的代理不得进行以上所述违规推广，如有发现美逛将对淘客账号进行相应处理；<br>
                    （四）禁止用美逛头像的微信/QQ号在同行的社群中炸群，做有损美逛和淘宝联盟名义的事情，否则美逛官方将视情节严重性给予相应处罚！<br>
                    （五）淘客在推广美逛APP同时，禁止使用官方名义进行收费，如出现违规行为与组团平台无关。<br>
                    （六）禁止淘客从事违法活动或推广，淘客自行对其违反管理制度的行为承担责任；<br>
                    （七）美逛是淘宝第三方合作伙伴，非阿里旗下公司，请勿虚假夸大宣传；<br>
                    （八）禁止 恶意诋毁、贬损或攻击组团推和美逛及其相关业务。<br>
                    情节严重者将永久停止合作，禁用组团所有账号！如被联盟投诉，美逛将配合联盟要求进行相关处理。<br>
                    第九条  不得存在如下任一情形：<br>
                    （一）   出现违反国家法律法规、行政规章等规定，或违反公序良俗的情形。如使用虚假或易使用户误会的言辞或推广用语等。<br>
                    （二） 仿冒品牌官网进行推广，或使用其他令用户误认为获得被推广品牌官方授权的描述、介绍。<br>
                    （三）  采用暴力营销等易给用户造成不良影响的方式推广。<br>
                    （四）其他组团推有合理理由认为不合适的行为。<br>
                    第十条 组团推数据使用限制：对合作过程中组团推或其关联公司提供的数据，应按组团推或其关联公司事先确认方式使用，不得擅自复制、储存、编辑、公布、出租、出售或以其它方式披露或使用前述数据 <br>
                    <h5>第四章    违规认定与处理</h5>
                    推广者应以诚实信用为原则，严格遵守本规范规定。为构建和谐健康的推广环境，组团推将按本章节规定进行违规认定与处理。<br>
                    第十一条 涉嫌违规<br>
                    （一）   认定标准<br>
                    符合下述任一的，即可认定推广行为涉嫌违规：<br>
                    1、组团推过滤系统对一定周期内的推广数据进行排查后，抓取到异常推广数据的。<br>
                    2、人工抓取分析后，有初步证据显示推广行为违反本规范的。<br>
                    （二）   临时措施<br>
                    1、组团推会基于其独立认定的事实（涉嫌违规性质、严重程度等，下同），独立确定要采取的临时措施。临时措施有暂停结算收入、暂时收回权限等。<br>
                    2、  执行时间：组团推给推广者发涉嫌违规通知的同时生效执行。<br>
                    （三）   通知<br>
                    1、认定涉嫌违规的，组团推会给推广者发送通知，通知内容包括被采取的临时措施、申诉途径要求等。<br>
                    2、违规认定依据的特别说明：<br>
                    1）组团推过滤系统涉及组团推核心商业秘密。如若系统监测数据结果、判断逻辑等被公开，会被部分恶意推广者利用进而规避、损害其他推广者、被推广商家的利益。<br>
                    2）组团推将根据过滤系统排查的数据，告知推广者其涉嫌违规的行为类型。如推广者对涉嫌违规认定存在异议的，可申诉，组团推同时会告知推广者如何提供申诉材料，并校验申诉材料能否解释系统排查的异常数据，进而做出违规认定。<br>
                    3）如涉及纠纷，在国家相关部门处理过程中，组团推将视情况向相关部门提供违规认定依据。<br>
                    第十二条 申诉  
                    （一）   申诉指涉嫌违规的推广者按要求提交材料以证明其推广合规。<br>
                    （二）   提交：<br>
                    1、推广者应在涉嫌违规通知发出后7日内，按组团推指定方式提交申诉材料。<br>
                    2、推广者应就其每一涉嫌违规行为单独提交申诉，单独提供材料证明合规。<br>
                    （三）   结果认定：<br>
                    1、认定主体：由组团推基于申诉材料等内容独立判断完成。<br>
                    2、时间要求：组团推收到推广者申诉后5个工作日内完成并反馈推广者。<br>
                    3、申诉成功的，涉嫌违规不成立，会解除临时措施，更不会执行其他处理措施。<br>
                    4、申诉不成功或逾期未申诉的，组团推会认定违规成立，并按规范进行处理。<br>
                    第十三条 违规成立处理<br>
                    1、  组团推会基于其独立认定的事实，独立确定要采取的正式处理措施，相应临时措施在正式处理措施执行的同时解除。正式处理措施有收回权限、终止合作、联盟投诉等。<br>
                    2、正式处理措施生效执行时间：<br>
                    1）推广者申诉不成功的，组团推发出申诉不成功通知的同时，正式处理措施立即生效执行。<br>
                    2）推广者逾期未申诉的，申诉期满当日24点生效执行。<br>
                    第十四条【证据保管】鉴于组团推推广数据过于庞大且维护难度大，推广者同意组团推对证明推广者涉嫌违规的证据保管期限为组团推通知涉嫌违规之日起算六十天。<br>
                    第十五条 声明<br>
                    1、组团推推广者自行对其违反管理制度的行为承担责任；<br>
                    2、集团公司不对组团推广这的违法行为负责，若推广者违反管理制度的行为给集团公司造成损失，则相关违规流量主应对集团公司进行赔偿。<br>

                    <h5>第五章    附则</h5>
                    第十六条  本规范的标题仅为方便阅读所设，非对具体条款内容的定义、限制、解释或描述其范围或界限。<br>
                    第十七条  本规范未作定义的词语或术语，如在《组团推服务协议》、《淘宝客推广软件产品使用许可协议》等已有定义的，适用其定义；如未进行定义的，按照上下文意思及该词语或术语的通常含义理解。<br>
                    第十八条  本规范于2019年【1】月【1】日发布，自发布之日起生效。<br>
                </div>
                <div class="a-bottom"
                     @click="closeArgee">
                    我已阅读并知晓，下次不再提示
                </div>
            </div>
        </div>
        <div id="content">
            <div class="body">
                <div class="head">
                    <div :class="IsRegister ? 'child active':'child'"
                         v-on:click="goRegister(1)">
                        注册
                    </div>
                    <div :class="IsRegister ? 'child':'child active'"
                         v-on:click="goRegister(0)">
                        登录
                    </div>
                </div>
                <div class="register"
                     v-if="IsRegister"
                     @keyup.enter="onRegister">
                    <div v-show="!zhuceSelect">
                        <input type="text"
                               class="e-mail"
                               placeholder="邮箱账号"
                               v-model="Email">
                        <input type="text"
                               placeholder="手机号码"
                               v-model="phoneNumber">
                        <input type="text"
                               class="yzinput"
                               v-model="picYZ">
                        <div class="img"
                             @click="getpicYZ"><img :src="'/api/u/getvalidatecode?guid='+ guid"
                                 alt=""></div>
                        <input type="text"
                               placeholder="验证码"
                               class="validate"
                               v-model="yanzheng">
                        <button class="getValidate"
                                v-if="time == '获取验证码'"
                                v-on:click="onValidate">{{time}}</button>
                        <button class="getValidate"
                                v-else>{{time}}</button>
                        <input type="password"
                               placeholder="输入密码"
                               v-model="password">
                        <input type="password"
                               placeholder="再次输入密码"
                               v-model="passwordRepeat">
                        <div class="agreement"></div>
                        <div class="button"
                             v-on:click="onRegister">
                            <span v-if="error">{{error}}</span>
                            注册
                        </div>
                        <div class="goLogin">
                            <!-- <i style="float: left">注册即代表同意<a href="/staticHtml/agreement/agreement.html" target="_blank">《组团用户注册协议》</a></i> -->
                            <i style="float: left;text-align: left">
                                注册即代表同意
                                <template v-if="TkType == 1">
                                    <a href="/staticHtml/agreement/flowAgree.html?tkType=1"
                                       target="_blank">《组团用户注册协议》</a>
                                    <a href="/staticHtml/agreement/attractAgree.html?tkType=1&type=1"
                                       target="_blank">《隐私政策》</a>
                                    和<a href="/staticHtml/agreement/tjAgree.html"
                                       target="_blank">《软件许可使用协议》</a>
                                </template>
                                <template v-if="TkType == 2">
                                    <a href="/staticHtml/agreement/attractAgree.html?tkType=2&type=0"
                                       target="_blank">《组团用户注册协议》</a>
                                    <a href="/staticHtml/agreement/attractAgree.html?tkType=1&type=1"
                                       target="_blank">《隐私政策》</a>
                                </template>
                            </i>
                            <i style="float: right">已有账户？<i v-on:click="goRegister(0)">点击登录</i></i>
                        </div>
                    </div>
                    <div v-show="zhuceSelect"
                         style="padding-bottom: 60px;height: 250px">
                        <div class="reg-item"
                             @click="TkType = 1;ShowGetUserPhoneDialog()">
                            <p class="p1">我是流量主</p>
                            <p class="p2">我要推广APP赚钱</p>
                        </div>
                        <div class="reg-item"
                             style="float: right"
                             @click="TkType = 2;zhuceSelect = false">
                            <p class="p1">我是招商淘客</p>
                            <p class="p2">我要放单推广商品</p>
                            <p class="p2"
                               style="font-size: 12px;">注册招商不能使用APP功能</p>
                        </div>
                        <a class="reg-a"
                           href="/businesEnter.html"
                           target="_blank">了解放单入住流程</a>
                    </div>
                </div>
                <div class="login"
                     v-else
                     @keyup.enter="loginZt">
                    <input type="text"
                           class="userName"
                           placeholder="请输入邮箱账号登录"
                           v-model="userName"
                           v-on:blur="IsCode">
                    <input type="password"
                           placeholder="密码6-25位字母+数字"
                           v-model="userPassword"
                           v-on:blur="IsCode">
                    <div v-if="needYz">
                        <input type="text"
                               class="yzinput"
                               v-model="picYZ">
                        <div class="img"
                             @click="getpicYZ"><img :src="'/api/u/getvalidatecode?guid='+ guid"
                                 alt=""></div>
                    </div>
                    <!--<div class="hua" ref="dragDiv">-->
                    <!--<div class="drag_bg"></div>-->
                    <!--<div class="drag_text">{{confirmWords}}</div>-->
                    <!--<div ref="moveDiv" @mousedown="mousedownFn($event)" :class="{'handler_ok_bg':confirmSuccess}"-->
                    <!--class="handler handler_bg" style="position: absolute;top: 0px;left: 0px;"></div>-->
                    <!--</div>-->
                    <div class="choose">
                        <input type="checkbox"
                               v-model="automatic">
                        <span @click="automatic= !automatic"
                              style="cursor: pointer">30天自动登录</span>
                        <a href="forget.html"
                           style="font-size: 14px; color:#f9513b;float: right">忘记密码 ?</a>
                    </div>
                    <div class="button"
                         v-on:click="loginZt">
                        <span v-if="error1">{{error1}}</span>
                        登录
                    </div>
                    <div class="goRegister">
                        还不是组团用户？ <i v-on:click="goRegister(1)">10秒快速注册</i>
                    </div>
                </div>

            </div>
            <div class="kefu-info-container">
                <!-- <div class="kefu-ercode consult1">
                <h3>组团咨询导师1</h3>
                <p style="line-height:2;">微信号：zutuanlianmeng7</p>
                <img src="http://htmlcdn.meihuiyoupin.cn/static/images/images-zt/zt_consult1.png" width="112" height="108" alt="">
              </div>
              <div class="kefu-ercode consult2">
                <h3>组团三哥</h3>
                <p style="line-height:2;">微信号：meiguang3g</p>
                <img src="http://htmlcdn.meihuiyoupin.cn/static/images/images-zt/consult3g.png" width="112" height="108" alt="">
              </div> -->
                <!-- <div class="kefu-ercode consult2">
                <h3>组团咨询导师2</h3>
                <p style="line-height:2;">微信号：mxg878878</p>
                <img src="http://htmlcdn.meihuiyoupin.cn/static/images/images-zt/zt_consult2.png" width="112" height="108" alt="">
              </div> -->
                <!-- <div class="kefu-ercode" style="position: absolute;top: -196px;left: 112px;text-align: center;">
                <h3>组团咨询导师3</h3>
                <p style="line-height:2;">微信号：mg13856876492</p>
                <img src="http://htmlcdn.meihuiyoupin.cn/static/images/images-zt/zt_consult3.png" width="112" height="108" alt="">
              </div> -->
            </div>

            <div class="logo"></div>
            <div class="back">

            </div>
            <div class="title">
                <div class="line-1">已有278658人正在使用组团</div>
                <div class="line-2"
                     style="width:500px;"><i>100%人工审核</i> <i>实时维护排查</i> <i>每日持续上新</i></div>
            </div>
        </div>
        <div class="bottom">
            <div class="line-1">
                <a href="index.html">网站首页</a> | <a href="aboutWe.html">关于我们</a> | <a href="aboutWe.html">联系我们</a> | <a href="javascript:;">商务合作</a> | <a href="http://help.zutuan.cn/">帮助中心</a>
            </div>
            <div class="line-2">
                ©copyright 2010-2019 组团推 www.zutuan.cn.浙ICP备 16028266号-4 杭州四禾电子商务有限公司<span id="cnzz_stat_icon_1276337123"></span>
            </div>
        </div>
        <!--<Iframe id="iframe1" ref="Iframe1" @iframeIsLodeChange="iframeIsLodeChange" iframeIsLode="iframeIsLode"-->
        <!--:loadingUrl="LoadUser"></Iframe>-->
       <el-dialog title="账号注册" :visible.sync="dialogPhone" class="getphone-dialog" center width="450px">
           <div class="content">
                <div class="getphone-item">
                    <span>手机号：</span>
                    <input type="text" name="" value="" class="large" v-model="userPhone" placeholder="请输入手机号">
                </div>
                <div v-if="mistakeTips" class="mistake">
                    {{mistakeTips}}
                </div>
           </div>
           <div class="foot">
               <div class="btn" @click="checkUserPhone">下一步</div>
           </div>
        </el-dialog>
        <el-dialog  title="账号注册" :visible.sync="dialogPhone2" class="getphone-dialog" center width="450px">
            <div class="content-center">
                请联系客服微信：{{WXCode}}
            </div>
           <div class="foot">
               <div class="btn" @click="dialogPhone2=false">我知道了</div>
           </div>
        </el-dialog>
           <el-dialog  title="账号注册" :visible.sync="dialogPhone3" class="getphone-dialog" center width="450px">
            <div class="content-center">
                请联系客服完成注册
            </div>
            <div class="content-img">
                <img src="http://htmlcdn.meihuiyoupin.cn/static/images/images-zt/zt_consult6.png" width="100%" height="100%" alt="">
            </div>
           <div class="foot">
               <div class="btn" @click="dialogPhone3=false">我知道了</div>
           </div>
        </el-dialog>
    </div>
</template>
<script>
    import Iframe from '../../components/common/iframe'
    import { LoadUser, LoadInfo, LoadTool, LoadAdmin, LoadCallback, LoadBuy } from '../../assets/js/api'
    import { iframepost } from '../../assets/js/ajax'
    import { tool } from '../../assets/js/api';
    import { request } from "../../assets/api/login";
    import Cookies from 'js-cookie'
import { Tree } from 'element-ui';
import { constants } from 'fs';
    const locaUrl = 'index.html';
    export default {
        data() {
            return {
                status: 0,
                post: null,
                //登录
                automatic: 0,
                userName: '',
                userPassword: '',
                needYz: false,

                //注册
                Email: '',
                phoneNumber: '',
                picYZ: '',
                guid: null,
                yanzheng: '',
                password: '',
                passwordRepeat: '',
                error: '',
                error1: '',
                time: '获取验证码',
                LocationHref: false,
                IsRegister: false,
                SemId: 0,
                ZhaoshangId: 0,
                InviteUserId: 0,
                IsArge: false,
                zhuceSelect: true,
                TkType: 2,
                // 注册弹框确认手机号
                dialogPhone:false,
                dialogPhone2:false,
                dialogPhone3:false,
                mistakeTips:'',
                userPhone:'',
                IsAgent:'',
                WXCode:'',
            }
        },
        watch: {
            IsRegister: function () {
                this.getpicYZ();
                this.userName = '';
                this.userPassword = '';
                this.Email = '';
                this.picYZ = '';
                this.yanzheng = '';
                this.password = '';
                this.passwordRepeat = '';
            }
        },
        methods: {
            onEnter() {
                if (this.IsRegister) {
                    this.onRegister()
                } else {
                    this.loginZt();
                }
            },
            closeArgee() {
                this.IsArge = false;
                if (!window.localStorage['arge']) {
                    window.localStorage['arge'] = 1
                }
            },
            // 获取默认
            iframeIsLodeChange(val) {
                if (val) {
                    this.post = this.$refs.Iframe1.getList;
                }

            },
            //获取图片验证码
            getpicYZ() {
                this.guid = Math.random();
                console.log(this.guid)
            },
            //点击注册
            onRegister() {
                if (this.Email && this.phoneNumber && this.yanzheng && this.password && this.passwordRepeat) {
                    let url
                    if (this.LocationHref) {
                        url = this.LocationHref
                    } else {
                        url = locaUrl
                    }
                    let data;
                    data = {
                        Code: this.yanzheng,
                        Email: this.Email,
                        PWD: this.password,
                        PWD2: this.passwordRepeat,
                        Mobile: this.phoneNumber,
                        RedirectUrl: decodeURIComponent(location.origin + '/user/index.html#/appbuy'),
                        SemId: this.SemId,
                        ZhaoshangId: this.ZhaoshangId,
                        InviteUserId: Cookies.get('inviteUser') || this.InviteUserId, // 优先取cookie
                        Status: this.status,
                        TkType: this.TkType
                    }


                    request.Register(data).then(msg => {
                        let res = msg.data
                        if (res.code) {
                            if (res.code == 1 || 2) {
                                this.error = res.msg;
                            }
                            return
                        }
                        Cookies.remove('inviteUser') // 移除cookie
                        this.loca(res)
                    })
                    // this.post('http://test.zt.cn/api/ajaxregister', 'post', data, res => {
                    //     i
                    // });

                }
                else {
                    this.error = '请输入所需信息'
                }
            },
            //获取验证码
            onValidate() {
                if (this.phoneNumber.trim()) {
                    if (this.picYZ.trim()) {
                        console.log(this.guid)
                        let data = {
                            Mobile: this.phoneNumber,
                            Code: this.picYZ,
                            Guid: this.guid,
                            Email: this.Email,
                        }
                        request.Validate(data).then(msg => {
                            let res = msg.data;
                            if (res.code != 0) {
                                this.error = res.msg;
                            } else {

                                let num = 60;
                                let time = setInterval(() => {
                                    num--;
                                    this.time = num + '秒后再次获取';
                                    if (num == 0) {
                                        clearInterval(time)
                                        this.time = '获取验证码'
                                    }
                                }, 1000)
                            }
                        })
                        // this.post('http://test.zt.cn/api/regsendcode', 'post', data, res => {
                        //
                        // });
                    } else {
                        this.error = '请输入图片验证码后进行操作';
                    }
                } else {
                    this.error = '请输入手机号码后再次获取'
                }


            },
            // 判断是否需要输入验证码
            IsCode() {
                this.error1 = ''
                let data = {
                    Email: this.userName
                }
                request.Code(data).then(res => {
                    if (res) {
                        if (res.data.code || res.data.code == 0) {
                            this.error1 = res.data.msg;
                            this.needYz = false
                        } else {
                            this.needYz = true
                        }
                    } else {
                        this.needYz = false
                    }
                })
                // this.post('http://test.zt.cn/api/checklogin', 'post', data, res => {
                //     this.needYz = res
                // });
            },
            //点击登录
            loca(e) {
                window.location.href = e
            },
            loginZt() {
                this.IsCode();
                if (this.userName && this.userPassword) {
                    let url
                    if (this.LocationHref) {
                        url = this.LocationHref
                    } else {
                        url = locaUrl
                    }
                    let data = {
                        Email: this.userName,
                        PWD: this.userPassword,
                        Rember: this.automatic,
                        RedirectUrl: url,
                        Code: this.picYZ,
                        Guid: this.guid,
                    }
                    request.login(data).then(msg => {
                        let res = msg.data

                        if (res.code) {
                            if (res.code == 1 || 2) {
                                this.error1 = res.msg;
                            };
                            return;
                        };
                        // // 设置第一次登录的cookie值,周期为7天
                        Cookies.set('isFirstLogin', 1, { expires: 1 });
                        this.loca(res);
                    })
                    // this.post('http://test.zt.cn/api/ajaxlogin', 'post', data, res => {
                    //
                    // });
                } else {
                    this.error1 = '请输入用户名或密码'
                }
            },
            goRegister(value) {
                if (value) {
                    this.IsRegister = true
                    console.log(this.InviteUserId)
                    if (this.InviteUserId) {
                        this.zhuceSelect = false
                        this.TkType = 1
                    } else {
                        this.zhuceSelect = true
                    }

                } else {
                    this.IsRegister = false
                }
            },
            //判断是否为手机浏览器登录，并跳转到对应页面
            isPhoneVisited() {
                // let ahref = location.href.replace('login.html', 'loginp.html')
                // if (/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
                //     window.location.href = ahref;
                // } else {

                // }
            },
            // 打开输入手机的弹框
            ShowGetUserPhoneDialog(){
                  this.mistakeTips = '';
                  this.userPhone='';
                  this.dialogPhone = true;
            },
            //判断手机号
            checkUserPhone(){
                this.mistakeTips = '';
                if(this.userPhone.trim()==''){
                    this.mistakeTips = '请输入手机号';
                    return false;
                }
                if (!(/^1(3|4|5|6|7|8|9)\d{9}$/.test(this.userPhone.trim()))) {
                    this.mistakeTips='手机号格式错误';
                    return false;
                }
                //mobile
                let data = {
                    mobile: this.userPhone.trim(),
                }
                request.getWx(data).then(msg => {
                    console.log(msg)
                    let res = msg.data;
                    console.log(res);
                    if (res.Code != 0) {
                        this.mistakeTips = res.Msg;
                    } else {
                        this.IsAgent = res.Data.IsAgent;
                        this.WXCode = res.Data.WXCode;
                        this.dialogPhone=false
                        if(this.IsAgent){
                            this.dialogPhone2=true
                        }else{
                            this.dialogPhone3=true
                        }
                    }
                })
            },
        },
        mounted() {
            let arges = window.localStorage.arge;
            console.log(arges)
            if (!arges) {
                this.IsArge = true;
            }
            //cnzz
            var cnzz_protocol = (("https:" == document.location.protocol) ? "https://" : "http://");
            document.head.appendChild(document.createElement('script')).src = "" + cnzz_protocol + "s5.cnzz.com/z_stat.php?id=1276337123&show=pic1";
            this.isPhoneVisited();
            this.getpicYZ();
            let a = this.$route.path;
            let href = tool.GetPartParam(a, 'redirectUrl');
            let status = tool.GetPartParam(a, 'status');
            let SemId = tool.GetPartParam(a, 'SemId');
            let ZhaoshangId = tool.GetPartParam(a, 'ZhaoshangId');
            let InviteUserId = tool.GetPartParam(a, 'InviteUserId');
            if (InviteUserId) {
                this.TkType = 1
                this.zhuceSelect = false
                Cookies.set('inviteUser', InviteUserId, { expires: 1 });
            }
            console.log('邀请人信息', InviteUserId)
            if (href) {
                href = decodeURIComponent(href);
                this.LocationHref = href
            }
            if (status) {
                this.status = status;
                this.IsRegister = parseInt(status)
            }
            this.SemId = SemId;
            this.ZhaoshangId = ZhaoshangId;
            this.InviteUserId = InviteUserId
        }
    }
</script>
<style scoped>
    @import "./static/css/login.css";
</style>
<style lang="css">
    .kefu-info-container {
      position: absolute;
      width: 440px;
      top: 256px;
      z-index: 500;
    }
    .consult1 {
      float: left;
    }
    .consult2 {
      float: right;
    }
    .getphone-dialog{

    }
    .getphone-dialog .content .getphone-item{
        margin-bottom: 20px;
    }
    .getphone-dialog .content .getphone-item.inline-item{
        display: inline-block;
    }
    .getphone-dialog .content input.large{
        height: 30px;
        width: 300px;
        line-height:30px;
        padding:0 10px;
    }
    .getphone-dialog .content .mistake{
        padding-left:63px;
        color: #f9513b;
        height: 18px;
        line-height:18px;
        font-size:14px;
    }
    .getphone-dialog .content-img{
        padding-top:10px;
        width:150px;
        height:150px;
        margin:0 auto;
    }
    .getphone-dialog .content-center{
        line-height:30px;
        font-size:14px;
        text-align:center;
    }
    .getphone-dialog .foot{
        padding-top:18px;
    }

    .getphone-dialog .foot .btn{
        width:200px;
        height:35px;
        line-height:35px;
        background: #f9513b;
        border-radius: 5px;
        color:#fff;
        font-size:16px;
        margin:0 auto;
        text-align:center;
    }

</style>
